<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row>
                  <b-col lg="5" md="5">
                    <h5 class="mt-2" v-text="title" />
                  </b-col>
                  <b-col lg="3" md="3" class="text-right pl-0">
                    <b-input-group size="md" class="box-shadow">
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model="barcode"
                        placeholder="Scan or enter barcode"
                        @keyup.esc="barcode = ''"
                        class="search"
                        autocomplete="off"
                        v-shortkey.focus="['ctrl', 's']"
                        @keypress.enter="addProduct"
                        autofocus
                        ref="search"
                      />
                    </b-input-group>
                    <transition name="slide">
                      <div class="product-search" v-show="barcode != ''">
                        <div class="box-shadow">
                          <ul
                            id="product-list"
                            v-if="productSearch.length !== 0"
                          >
                            <li
                              v-for="item in productSearch"
                              :key="item.index"
                              class="get-product"
                              @click="addProductClick(item)"
                            >
                              <b-row>
                                <b-col class="w-75">
                                  <h6 v-text="item.name" />
                                </b-col>
                                <b-col class="w-25">
                                  <span v-text="currencySymbol + item.mrp" />
                                </b-col>
                              </b-row>
                            </li>
                          </ul>
                          <div
                            class="row align-items-center notification"
                            style="height:100%"
                            v-else
                          >
                            <h6 class="text-center w-100">No product found.</h6>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </b-col>
                  <b-col lg="2" md="2" class="pl-0 pr-2">
                    <b-button
                      variant="outline-primary"
                      block
                      @click="$router.push('/order-summary/' + order_id)"
                      >Cancel</b-button
                    >
                  </b-col>
                  <b-col lg="2" md="2" class="pl-0">
                    <b-button
                      variant="primary"
                      block
                      :disabled="!totalPack.isPacked"
                      @click="orderPack()"
                    >
                      Confirm Completion
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="mt-2">
        <b-container fluid>
          <b-row>
            <b-col lg="5" md="5">
              <div class="table-dark-bg box-shadow p-3 pb-0">
                <p class="fs-14 py-2 px-1 total-packed">
                  <img
                    v-if="totalPack.count != totalProducts.length"
                    src="../assets/images/icon_success.svg"
                    alt=" "
                    class="mr-1"
                  />
                  <img
                    v-if="totalPack.count == totalProducts.length"
                    src="../assets/images/icon_success_color.svg"
                    alt=" "
                    class="mr-1"
                  />
                  <span
                    v-text="
                      `${totalPack.count} of ${totalProducts.length} ordered products packed`
                    "
                  />
                </p>
                <b-row class="th-header py-2 pl-2">
                  <b-col md="5">Product Particulars</b-col>
                  <b-col md="3">Unit MRP</b-col>
                  <b-col md="2">Packed</b-col>
                  <b-col md="2">&nbsp;</b-col>
                  <!-- <b-col md="2">&nbsp;</b-col> -->
                </b-row>
                <div class="packed-products">
                  <b-row
                    class="py-3 pl-4 fs-13 align-items-center"
                    v-for="item in state.stock.orderProductList"
                    :key="item.barcode"
                    :class="{ discarded: item.is_discarded }"
                  >
                    <b-col md="5">
                      <span
                        class="barcode"
                        :class="{
                          'text-danger':
                            !omsInventoryBlockingLevel && !item.is_available,
                        }"
                        v-text="item.barcode"
                      />
                      <p
                        class="mb-0"
                        v-text="splitText(item.name, 25)"
                        v-b-tooltip.hover
                        :title="item.name.length > 25 ? item.name : ''"
                      />
                    </b-col>
                    <b-col
                      md="3"
                      v-text="currencySymbol + formatAmount(item.mrp)"
                    />
                    <b-col md="2">
                      <p
                        class="mb-0"
                        v-if="item.weight_flag"
                        v-text="`${item.qty} ${item.uom}`"
                      />
                      <p
                        class="mb-0"
                        v-else
                        v-text="`${item.packed_qty} of ${item.qty}`"
                      />
                    </b-col>
                    <b-col md="2">
                      <div class="d-flex">
                        <img
                          v-show="!item.isPacked && !item.is_discarded"
                          src="../assets/images/icon_success.svg"
                          alt=" "
                        />
                        <img
                          v-show="item.isPacked"
                          src="../assets/images/icon_success_color.svg"
                          alt=" "
                        />
                        <b-link
                          class="text-success action-btns py-2"
                          @click="keepPopUp(item)"
                          v-show="item.is_discarded"
                        >
                          <font-awesome-icon :icon="['fas', 'check']" />
                          Keep</b-link
                        >
                        <b-dropdown
                          size="sm"
                          variant="link"
                          toggle-class="text-decoration-none mr-4"
                          no-caret
                          class="ml-2"
                          v-show="
                            !item.isPacked &&
                              !item.is_discarded &&
                              !omsInventoryBlockingLevel
                          "
                        >
                          <template v-slot:button-content>
                            <font-awesome-icon :icon="['fa', 'ellipsis-v']" />
                          </template>
                          <b-dropdown-item
                            @click="dropDownAction('replace', item)"
                            :disabled="omsInventoryBlockingLevel"
                            >Replace product</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="dropDownAction('discard', item)"
                            :disabled="omsInventoryBlockingLevel"
                            >Discard product</b-dropdown-item
                          >
                        </b-dropdown>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col lg="7" md="7" class="pl-0">
              <div class="table-dark-bg box-shadow p-3 pb-0 final-products">
                <p class="fs-14 py-2 px-1">
                  <span
                    class="light-grey"
                    v-text="`${packedOrderQty}`"
                    v-if="orderProdType.peice"
                  />
                  <span
                    class="light-grey"
                    v-text="` | `"
                    v-if="orderProdType.peice && orderProdType.weight"
                  />
                  <span
                    class="light-grey"
                    v-text="`${packedOrderWeightQty}`"
                    v-if="orderProdType.weight"
                  />
                  <!-- <span class="light-grey px-2">|</span> -->
                  <!-- <span class="light-grey">0 of 4.0 kg scanned</span> -->
                </p>
                <b-row class="th-header py-2 pl-2">
                  <ul class="list-inline mb-0 w-100">
                    <li class="text-center">#</li>
                    <li>Product Particulars</li>
                    <li>Batch/Serial</li>
                    <li>Quantity</li>
                    <li>Unit MRP</li>
                    <li>Total</li>
                  </ul>
                </b-row>
                <div class="final-products-cont">
                  <div v-if="packedProduct.length != ''">
                    <ul
                      class="th-header list-inline mb-0 w-100 d-flex align-items-center py-3"
                      v-for="(item, index) in packedProduct"
                      :key="index"
                    >
                      <li class="text-center" v-text="`${index + 1}`" />
                      <li>
                        <span class="barcode" v-text="item.barcode" />
                        <p
                          class="mb-0"
                          v-text="splitText(item.name, 25)"
                          v-b-tooltip.hover
                          :title="item.name.length > 25 ? item.name : ''"
                        />
                      </li>
                      <li class="pr-3" v-if="item.batch_list.length > 0">
                        <b-input-group
                          class="select-batch"
                          @click="
                            openSelectBatchModal(
                              item.batch_list,
                              item.barcode,
                              item.selected_batch,
                              item
                            )
                          "
                          v-b-tooltip.hover
                          :title="`Change ${item.invType}`"
                          v-if="item.type != 'kg'"
                        >
                          <b-form-input
                            v-model="item.invCode"
                            class="fs-12"
                            disabled
                          />
                          <template v-slot:append>
                            <font-awesome-icon :icon="['fa', 'angle-right']" />
                          </template>
                        </b-input-group>
                      </li>
                      <li class="pr-3" v-if="item.batch_list.length == 0">-</li>
                      <li class="pr-3">
                        <select
                          class="custom-select custom-select-sm fs-12"
                          v-model="item.qty"
                          @change="updateQty(item.barcode, $event.target.value)"
                          v-if="!item.weight_flag"
                        >
                          <option
                            v-for="nqty in helper.getRange(item.max_qty)"
                            :key="nqty"
                            v-text="nqty"
                            :value="nqty"
                            :selected="nqty == parseInt(item.packed_qty)"
                          />
                        </select>
                        <p
                          class="mb-0"
                          v-if="item.weight_flag"
                          v-text="`${item.qty} ${item.uom}`"
                        />
                      </li>
                      <li v-text="currencySymbol + formatAmount(item.price)" />
                      <li>
                        <div
                          class="float-left"
                          v-text="currencySymbol + formatAmount(item.total)"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'info-circle']"
                            class="ml-2"
                            v-b-tooltip.hover.bottomCenter.html="item.tooltip"
                          />
                        </div>
                        <div class="float-right">
                          <b-link
                            v-b-tooltip.hover
                            title="Remove"
                            @click="removeProductFromPacked(item.barcode)"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'times']"
                              class="text-danger"
                            />
                          </b-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-center align-items-center h-100 light-grey"
                  >
                    Add products by scanning or entering their barcodes
                  </div>
                </div>
              </div>
              <select-batch-modal
                :open="openLGBox"
                @close-batch-modal="closeBatchModal"
                @update-batch="updateBatch"
                :options="batchList"
                :barcode="selectedBarcode"
                :batch="selectedBatch"
                :type="invType"
              ></select-batch-modal>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <order-replace-modal
        :open="openReplaceModal"
        :currentProduct="selectedProduct"
        @close-replace="(openReplaceModal = false), (selectedProduct = {})"
      />
      <b-modal
        ref="discard-product"
        id="discard-product"
        size="sm"
        hide-footer
        hide-header
        centered
      >
        <h6 class="mb-3 fw-normal">
          <img src="../assets/images/alert.svg" class="mr-1" />
          <span
            v-text="
              keep
                ? 'Keep Product'
                : getListCount
                ? 'Cancel Order'
                : 'Discard Product'
            "
          />
        </h6>
        <p>
          Are you sure you wish to
          <span v-text="keep ? 'keep' : 'discard'" /> the selected product?
        </p>
        <div v-show="!keep">
          <p>
            <span v-show="getListCount">
              Order will be cancelled and the customer will be refunded with the
              paid amount
              <span
                v-show="
                  (omsSettings.refund_mode.cash &&
                    !omsSettings.refund_mode.credit_note) ||
                    (!omsSettings.refund_mode.cash &&
                      omsSettings.refund_mode.credit_note)
                "
                v-text="
                  ` by: ${
                    omsSettings.refund_mode.cash ? 'Cash' : 'Store Credit'
                  }`
                "
            /></span>
            <span v-show="!getListCount">
              It will be removed from the order and the customer will be
              notified about the change.
            </span>
          </p>
          <b-form-group
            class="mt-2"
            v-if="
              getListCount &&
                omsSettings.refund_mode.cash &&
                omsSettings.refund_mode.credit_note
            "
          >
            <small for="refund-type">Select Mode of Refund</small>
            <b-form-radio-group
              id="invoice_type"
              v-model="orderRefund.type"
              :options="orderRefund.options"
              name="radio-options"
              class="mt-2 mb-2"
              style="padding-bottom: 8px;"
            />
          </b-form-group>
        </div>
        <p v-show="keep">
          It will be added to the order and the customer will be notified about
          the change.
        </p>
        <b-row class="mt-4">
          <b-col md="6">
            <b-button
              variant="outline-primary"
              block
              @click="
                $bvModal.hide('discard-product'),
                  (removeProduct = ''),
                  (keep = false)
              "
              v-shortkey="['esc']"
              @shortkey="$bvModal.hide('discard-product')"
            >
              Cancel
            </b-button>
          </b-col>
          <b-col md="6" class="pl-0">
            <b-button
              block
              @click="discardProduct(getListCount && !keep ? 'cancel' : '')"
              :disabled="$loading"
              variant="primary"
            >
              <span
                v-if="!$loading"
                v-text="keep ? 'Keep' : getListCount ? 'Continue' : 'Discard'"
              />
              <b-spinner small v-if="$loading" />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        title="Change in Order Amount"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        size="sm"
        ref="order-confirm-warning"
        id="order-confirm-warning"
      >
        <b-row v-if="orderAction.type == 'lower'">
          <b-col md="12">
            <p>
              Due to changes made to the order, the amount has been reduced by
              <span
                v-text="
                  `${currencySymbol}${formatAmount(orderAction.refundAmt)}`
                "
              />
            </p>
          </b-col>
          <b-col
            md="12"
            v-if="
              omsSettings.refund_mode.cash &&
                omsSettings.refund_mode.credit_note
            "
          >
            <p class="mt-2">
              How do you wish to refund the amount to the customer?
            </p>
            <b-form-group class="mt-2">
              <small for="refund-type">Select Mode of Refund</small>
              <b-form-radio-group
                id="invoice_type"
                v-model="orderRefund.type"
                :options="orderRefund.options"
                name="radio-options"
                class="mt-2 mb-2"
                style="padding-bottom: 8px;"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-else>
            <p
              class="mt-2"
              v-text="
                `The amount will be refunded to the customer by: ${
                  omsSettings.refund_mode.cash ? 'Cash' : 'Store Credit'
                }`
              "
            />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <p>
              Due to changes made to the order, the amount has been increased by
              <span
                v-text="
                  `${currencySymbol}${formatAmount(orderAction.refundAmt)}`
                "
              />
            </p>
            <p>
              This amount will be reflected in the 'Amount Due' section in order
              summary, payment for which can be collected before generating
              invoice.
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="6" class="pr-1">
            <b-button
              block
              :disabled="$loading"
              variant="outline-primary"
              @click="$refs['order-confirm-warning'].hide()"
              >Close</b-button
            >
          </b-col>
          <b-col md="6" class="pl-1">
            <b-button
              @click="
                orderPack(
                  orderAction.type == 'lower' ? orderRefund.type : 'greater'
                )
              "
              block
              :disabled="$loading"
              variant="primary"
            >
              <span v-if="!$loading">Confirm</span>
              <b-spinner small v-else />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <update-qty-modal
        :open="openWeightModal"
        :data="pdata"
        @close-modal="closeWightModal"
        :pluQty="pluQty"
        :toCart="false"
        @update-qty="updateWeightQty"
      />
    </template>
  </dashboard>
</template>

<script>
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import { BTooltip } from "bootstrap-vue";
import axios from "axios";
import { mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
// import qz from "../printer";
import SelectBatchModal from "../components/SelectBatchModal";
import * as helper from "../helper";
import OrderReplaceModal from "../components/OrderReplaceModal";
import { DISCARDED_PRODUCT, STOCK_UNAVAILABLE } from "../message";
import UpdateQtyModal from "../components/UpdateQtyModal";
import _ from "lodash";

library.add(faInfoCircle);
library.add(faEllipsisV);
export default {
  name: "order-packing",
  props: ["order_id"],
  components: {
    Dashboard,
    VSelect,
    BTooltip,
    SelectBatchModal,
    OrderReplaceModal,
    UpdateQtyModal,
  },
  created() {
    this.$store.commit("billing/setTransactionSubType", "order");
  },
  mounted() {
    this.orderRefund.type = this.omsSettings.refund_mode.cash
      ? "cash"
      : "credit";
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.state.billing.trans_sub_type == "order" &&
      ![`/order-summary/${this.order_id}`].includes(to.path)
    )
      this.$store.commit("billing/setTransactionSubType", "");
    next();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    totalPack() {
      let response = { count: 0, isPacked: false };
      response.count = this.state.stock.orderProductList.filter(
        (i) => i.isPacked === true && !i.is_discarded
      ).length;
      let finalProd = this.state.stock.orderProductList.filter(
        (i) => !i.is_discarded
      );
      response.isPacked = response.count === finalProd.length;
      return response;
    },
    // totalAccumQty() {
    //   let nonWeight = 0;
    //   let weight = 0;
    //   this.state.stock.orderProductList.map((item) => {
    //     if (!item.weight_flag) nonWeight += parseInt(item.packed_qty);
    //     else weight += parseInt(item.packed_qty);
    //   });
    //   return "Weight: " + weight + " NOn: " + nonWeight;
    // },
    // totalAccumQty() {
    //   let string = "";
    //   let pstring = "";
    //   let wstring = "";
    //   let pieceProductList = this.state.stock.orderProductList.filter(
    //     (i) => i.weight_flag === false
    //   );
    //   let weightProductList = this.state.stock.orderProductList.filter(
    //     (i) => i.weight_flag === true
    //   );
    //   if (pieceProductList.length !== 0) {
    //     pstring =
    //       _.sumBy(pieceProductList, (x) => parseFloat(x.packed_qty)) +
    //       " of " +
    //       _.sumBy(pieceProductList, (x) => parseFloat(x.qty)) +
    //       " quantities";
    //   }
    //   if (weightProductList.length !== 0) {
    //     pstring =
    //       _.sumBy(weightProductList, "packed_qty") +
    //       " of " +
    //       _.sumBy(weightProductList, "qty");
    //   }
    //   if (pstring != "" && wstring != "") string = pstring + " | " + wstring;
    //   if (pstring != "") string = pstring;
    //   if (wstring != "") string = wstring;
    //   return string + " scanned";
    // },
    packedProduct() {
      let temp = [];
      this.state.stock.orderProductList.forEach((i) => {
        if (i.packed_qty > 0) {
          let code = i.batch_list.filter((bat) => bat.id == i.selected_batch);
          let inv_type = "";
          if (i.hasOwnProperty("inv_type")) inv_type = i.inv_type;
          else inv_type = i.invType;
          temp.push({
            name: i.name,
            barcode: i.barcode,
            qty: i.weight_flag
              ? parseFloat(i.packed_qty)
              : parseInt(i.packed_qty),
            max_qty: i.weight_flag ? parseFloat(i.qty) : parseInt(i.qty),
            price: i.mrp,
            total: parseFloat(i.stotal) * parseFloat(i.packed_qty),
            selected_batch: i.selected_batch,
            batch_list: i.batch_list,
            weight_flag: i.weight_flag,
            uom: i.uom,
            invType: inv_type,
            invCode: code == undefined || code.length == 0 ? "-" : code[0].code,
            tooltip: {
              customClass: "custom-tooltip pack-order",
              title:
                "<div class='row fs-11'><div class='col-6 text-left'>Subtotal<br>Taxes</div><div class='col-6 text-right'>" +
                this.currencySymbol +
                parseFloat(i.ssubtotal) * parseFloat(i.packed_qty) +
                "<br>" +
                this.currencySymbol +
                parseFloat(i.stax) * parseFloat(i.packed_qty) +
                "</div></div>",
            },
          });
        }
      });
      return temp;
    },
    helper() {
      return helper;
    },
    productSearch() {
      let temp = [];
      let code = this.barcode;
      if (
        this.state.system.plu_data.status &&
        _.includes(this.barcode, this.state.system.plu_data.delimiter)
      ) {
        let data = _.split(this.barcode, this.state.system.plu_data.delimiter);
        code =
          this.state.system.plu_data.format == "suffix" ? data[0] : data[1];
      }
      this.state.stock.orderProductList.filter((item) => {
        if (code != "" && !item.isPacked) {
          if (
            item.barcode.toLowerCase().indexOf(code.toString().toLowerCase()) !=
              -1 ||
            item.name.toLowerCase().indexOf(code.toString().toLowerCase()) != -1
          )
            temp.push(item);
        }
      });
      return temp;
    },
    packedOrderQty() {
      let temp = { total: 0, packed: 0 };
      this.state.stock.orderProductList.forEach((item) => {
        if (!item.weight_flag && !item.is_discarded) {
          temp.total += parseInt(item.qty);
          temp.packed += parseInt(item.packed_qty);
        }
      });
      let packed = `${temp.packed} of ${temp.total} quantities`;
      return packed;
    },
    packedOrderWeightQty() {
      let temp = { total: 0, packed: 0 };
      this.state.stock.orderProductList.forEach((item) => {
        if (item.weight_flag && !item.is_discarded) {
          temp.total += item.qty;
          temp.packed += item.packed_qty;
        }
      });
      let packed = `${parseFloat(temp.packed).toFixed(2)} of ${parseFloat(
        temp.total
      ).toFixed(2)} kg scanned`;
      return packed;
    },
    orderProdType() {
      let temp = { weight: false, peice: false };
      let weight = this.state.stock.orderProductList.filter((item) => {
        return item.weight_flag && !item.is_discarded;
      });
      let piece = this.state.stock.orderProductList.filter((item) => {
        return !item.weight_flag && !item.is_discarded;
      });
      if (weight.length == this.state.stock.orderProductList.length)
        temp.weight = true;
      else if (piece.length == this.state.stock.orderProductList.length)
        temp.peice = true;
      else if (piece.length == 0 && weight.length != 0)
        temp = { peice: false, weight: true };
      else if (weight.length == 0 && piece.length != 0)
        temp = { peice: true, weight: false };
      else temp = { peice: true, weight: true };

      return temp;
    },
    omsSettings() {
      return this.$store.getters["omsSettings"];
    },
    omsInventoryBlockingLevel() {
      return (
        this.$store.getters["omsInventoryBlockingLevel"] == "order_created" ||
        this.$store.getters["omsInventoryBlockingLevel"] == "order_confirmed"
      );
    },
    inventoryBlockingInvoice() {
      return (
        this.$store.getters["omsInventoryBlockingLevel"] == "invoice_generated"
      );
    },
    // checkDiscardedProducts() {
    //   let temp = true;
    //   let list = this.state.stock.orderProductList;
    //   let discarded = [];
    //   if (list.length == 1) return temp;
    //   list.forEach((item) => {
    //     if (item.is_discarded) discarded.push(item);
    //   });
    //   let diff = list.length - discarded.length;
    //   if (diff >= 2) temp = false;

    //   return temp;
    // },
    totalProducts() {
      return this.state.stock.orderProductList.filter((i) => !i.is_discarded);
    },
    getListCount() {
      let list = this.state.stock.orderProductList;
      let data = list.filter((i) => i.is_discarded);
      return list.length - data.length == 1;
    },
  },
  data() {
    return {
      title: "Pack Order",
      barcode: "",
      openLGBox: false,
      batchList: [],
      selectedBarcode: "",
      selectedBatch: {},
      openReplaceModal: false,
      selectedProduct: {},
      removeProduct: {},
      keep: false,
      invType: "",
      orderAction: {
        refundAmt: "",
        type: "",
      },
      orderRefund: {
        options: [
          { text: "Cash", value: "cash" },
          { text: "Store Credit", value: "credit" },
        ],
        type: "cash",
      },
      openWeightModal: false,
      pluQty: "",
      pdata: {},
      userDetails: {
        comm_trans: "B2C",
        cust_gstin: null,
      },
    };
  },
  methods: {
    openSelectBatchModal(batchList, barcode, batch, i) {
      this.batchList = batchList;
      this.selectedBarcode = barcode;
      this.selectedBatch = batch;
      this.invType = i.invType;
      this.openLGBox = true;
    },
    closeBatchModal(data) {
      this.openLGBox = data;
      this.invType = "";
    },
    updateBatch(data) {
      let findProduct = _.find(this.state.stock.orderProductList, {
        barcode: data.barcode,
      });
      if (findProduct.selected_batch != data.batch_data) {
        findProduct.selected_batch = data.batch_data;
        findProduct.replaced = data.barcode;
      }
      this.$store.commit(
        "stock/setOrderProducts",
        this.state.stock.orderProductList
      );
      this.batchList = [];
      this.selectedBarcode = "";
      this.selectedBatch = {};
      this.openLGBox = false;
    },
    addProduct() {
      if (
        this.state.system.plu_data.status &&
        _.includes(this.barcode, this.state.system.plu_data.delimiter)
      ) {
        let data = _.split(this.barcode, this.state.system.plu_data.delimiter);
        this.barcode =
          this.state.system.plu_data.format == "suffix" ? data[0] : data[1];
        this.pluQty =
          this.state.system.plu_data.format == "suffix" ? data[1] : data[0];
      }
      let findProduct = _.find(this.state.stock.orderProductList, {
        barcode: this.barcode,
      });
      if (
        !this.omsInventoryBlockingLevel &&
        findProduct != undefined &&
        !findProduct.is_available &&
        !this.inventoryBlockingInvoice
      ) {
        this.barcode = "";
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: STOCK_UNAVAILABLE,
          type: "danger",
        });
        return;
      }
      if (findProduct != undefined && findProduct.is_discarded) {
        this.barcode = "";
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: DISCARDED_PRODUCT,
          type: "danger",
        });
        return;
      }
      if (findProduct == undefined) {
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: "Product not found",
          type: "danger",
        });
      } else {
        if (findProduct.weight_flag) {
          if (findProduct.isPacked) {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: "Item already packed.",
              type: "danger",
            });
          } else {
            this.pdata = Object.assign({ uom: "kg" }, findProduct);
            this.openWeightModal = true;
          }
        } else {
          if (findProduct.packed_qty < findProduct.qty) {
            findProduct.packed_qty = parseInt(findProduct.packed_qty) + 1;
            if (findProduct.packed_qty == findProduct.qty) {
              findProduct.isPacked = true;
            }
          } else {
            let alertData = {
              message: "Item already packed.",
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        }
        this.$store.commit(
          "stock/setOrderProducts",
          this.state.stock.orderProductList
        );
      }
      this.barcode = "";
    },
    removeProductFromPacked(barcode) {
      let findProduct = _.find(this.state.stock.orderProductList, {
        barcode: barcode,
      });
      findProduct.isPacked = false;
      findProduct.packed_qty = 0;
      this.$store.commit(
        "stock/setOrderProducts",
        this.state.stock.orderProductList
      );
    },
    updateQty(barcode, qty) {
      let findProduct = _.find(this.state.stock.orderProductList, {
        barcode: barcode,
      });
      findProduct.packed_qty = parseInt(qty);
      if (findProduct.qty == findProduct.packed_qty) {
        findProduct.isPacked = true;
      } else {
        findProduct.isPacked = false;
      }
      this.$store.commit(
        "stock/setOrderProducts",
        this.state.stock.orderProductList
      );
    },
    orderPack(via = "") {
      let filterProduct = _.cloneDeep(this.state.stock.orderProductList);
      filterProduct = _.map(filterProduct, (x, k) => {
        x.replaced = !this.checkEmpty(x.replaced) ? x.original_barcode : "";
        if (!x.is_discarded)
          return {
            id: x.id,
            barcode: x.barcode,
            batch:
              !this.checkEmpty(x.inv_type) && x.inv_type == "batch"
                ? x.selected_batch
                : "",
            serial:
              !this.checkEmpty(x.inv_type) && x.inv_type == "serial"
                ? x.selected_batch
                : "",
            qty: x.qty,
            packed_qty: x.packed_qty,
            replaced: x.replaced == undefined ? "" : x.replaced,
            unit_mrp: x.mrp,
            total_discount: x.total_discount,
            total: x.total,
            tax: x.tax,
          };
      });

      let data = Object.assign(
        {
          order_id: this.order_id,
          product_list: JSON.stringify(filterProduct),
          url: "/oms/order-pack",
          trans_from: "CLOUD_TAB_WEB",
        },
        this.essentialsData
      );

      if (via != "") data.via = via;

      axios.post(data.url, data).then((res) => {
        this.$loading = false;
        if (res.data.status == "info") {
          this.$refs["order-confirm-warning"].show();
          this.orderAction.refundAmt = res.data.refund_amount;
          this.orderAction.type = res.data.type;
        }
        if (res.data.status == "success") {
          if (via != "") this.$refs["order-confirm-warning"].hide();
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.$router.push("/order-summary/" + this.order_id);
          }, 100);
        }
      });
    },
    dropDownAction(type, item) {
      if (
        (type == "replace" && !this.omsSettings.is_replaced) ||
        (type == "discard" && !this.omsSettings.is_discard)
      ) {
        this.$store.commit("notifications/showAlert", {
          message: "Contact manager to enable this feature",
          type: "danger",
        });
        this.$showAlert = true;
        return;
      }
      this.selectedProduct = item;
      if (type == "replace") this.openReplaceModal = true;
      else if (type == "discard") this.discardPopUp(item);
    },
    discardPopUp(val) {
      this.removeProduct = val;
      this.$refs["discard-product"].show();
    },
    discardProduct(action = "") {
      if (action == "cancel") return this.cancelOrder();
      if (this.keep) return this.keepPopUp({}, "confirm");
      let list = this.state.stock.orderProductList;
      let index = _.findIndex(list, {
        barcode: this.removeProduct.barcode,
      });
      let removed = list.splice(index, 1);
      removed[0].is_discarded = true;
      removed[0].packed_qty = 0;
      list.push(removed[0]);
      this.$store.commit("stock/setOrderProducts", list);
      this.$showAlert = true;
      this.$store.commit("notifications/showAlert", {
        message: `Product discarded successfully (${this.removeProduct.name})`,
        type: "success",
      });
      this.$refs["discard-product"].hide();
    },
    async keepPopUp(prod = {}, status = "") {
      if (status == "") {
        this.keep = true;
        this.removeProduct = prod;
        this.$refs["discard-product"].show();
      } else {
        let list = this.state.stock.orderProductList;
        this.keep = false;
        await list.forEach((i) => {
          if (i.barcode == this.removeProduct.barcode) i.is_discarded = false;
        });
        this.$store.commit("stock/setOrderProducts", list);
        this.$refs["discard-product"].hide();
        this.$store.commit("notifications/showAlert", {
          message: `Product added successfully (${this.removeProduct.name})`,
          type: "success",
        });
        this.$showAlert = true;
      }
    },
    cancelOrder() {
      let data = Object.assign(
        {
          order_id: this.order_id,
          remark: "discarded from order pack",
          url: "/oms/cancel-order",
          refund_via: this.orderRefund.type,
        },
        this.essentialsData
      );

      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          this.$showAlert = true;
          window.history.back();
        }
      });
    },
    closeWightModal(data) {
      this.openWeightModal = false;
      this.pluQty = "";
    },
    updateWeightQty(data) {
      let findProduct = _.find(this.state.stock.orderProductList, {
        barcode: data.data.barcode,
      });
      this.openWeightModal = false;
      if (parseFloat(findProduct.qty) == parseFloat(data.updatedQty)) {
        findProduct.packed_qty = parseFloat(data.updatedQty);
        findProduct.isPacked = true;
        return;
      }
      let postdata = Object.assign(
        {
          barcode: data.data.barcode,
          url: "/oms/get-product-details",
          qty: parseFloat(data.updatedQty),
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
          type: "update",
          weight: true,
          from_screen: "pack",
        },
        this.essentialsData
      );
      axios.post(postdata.url, postdata).then((res) => {
        if (res.data.status != "fail") {
          this.updateProduct(res.data.data);
          findProduct.packed_qty = data.updatedQty;
          findProduct.isPacked = true;
        }
      });
    },
    async updateProduct(replaceProduct) {
      this.$loading = true;
      let list = await this.state.stock.orderProductList.filter((item) => {
        if (replaceProduct.barcode == item.barcode) {
          item.barcode = replaceProduct.barcode;
          item.qty = replaceProduct.qty;
          item.name = replaceProduct.item_name;
          item.mrp = replaceProduct.unit_mrp;
          item.total_discount = replaceProduct.total_discount;
          item.tax = replaceProduct.tax;
          item.total = replaceProduct.total;
          item.stotal =
            parseFloat(replaceProduct.total) / parseFloat(replaceProduct.qty);
          item.subtotal = replaceProduct.unit_mrp;
          item.ssubtotal =
            parseFloat(replaceProduct.unit_mrp) /
            parseFloat(replaceProduct.qty);
          item.id = replaceProduct.id;
          item.message = replaceProduct.message;
          item.is_sellable = replaceProduct.is_sellable;
          item.is_available = replaceProduct.is_available;
          item.available_qty = replaceProduct.available_qty;
          item.stock_point_name = replaceProduct.stock_point_name;
          item.weight_flag = replaceProduct.weight_flag;
          item.selected_batch =
            replaceProduct.batch_id != 0
              ? replaceProduct.batch_id
              : replaceProduct.serial_id;
          item.batch_list =
            replaceProduct.batch.length > 0
              ? replaceProduct.batch
              : replaceProduct.serial;
          item.replaced = replaceProduct.barcode;
          item.invType =
            replaceProduct.batch_id != 0
              ? "batch"
              : replaceProduct.serial_id != 0
              ? "serial"
              : "";
        }
        return item;
      });
      this.$store.commit("stock/setOrderProducts", list);
      this.$loading = false;
    },
    addProductClick(item) {
      if (
        this.state.system.plu_data.status &&
        _.includes(this.barcode, this.state.system.plu_data.delimiter)
      ) {
        let data = _.split(this.barcode, this.state.system.plu_data.delimiter);
        this.pluQty =
          this.state.system.plu_data.format == "suffix" ? data[1] : data[0];
      }
      this.barcode = item.barcode;
      this.addProduct();
    },
  },
};
</script>
<style lang="scss" scoped>
.total-packed,
.barcode,
.total-weight {
  color: $secondary-bg-btn;
}
.th-header {
  background: #e0e0e0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  font-size: 11px;
  color: $secondary-bg-btn;
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.12);
}
.packed-products {
  height: calc(100vh - 193px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    &:last-child {
      border-bottom: 0;
    }
  }
}
.discarded {
  border-left: 6px solid $grey-color;
  background-color: #ffeded;
}
.final-products {
  .th-header {
    margin-top: 19px;
    li {
      padding-right: 10px;
      &:nth-child(1) {
        width: 6%;
      }
      &:nth-child(2) {
        width: 30%;
      }
      &:nth-child(3) {
        width: 22%;
      }
      &:nth-child(4) {
        width: 10%;
      }
      &:nth-child(5) {
        width: 13%;
      }
      &:nth-child(6) {
        width: 17%;
      }
    }
  }
  .final-products-cont {
    height: calc(100vh - 190px);
    overflow-x: hidden;
    overflow-y: auto;
    margin-left: -15px;
    margin-right: -15px;
    @include custom-scrollbar();
    .th-header {
      background: none;
      font-size: 13px;
      box-shadow: none;
      margin-top: 0;
      padding-left: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }
  }
}
.light-grey {
  color: $dark-card-text;
}

.select-batch {
  &.highlighted {
    border: 1px solid #c0c0c0;
    border-radius: 0.25rem;
    user-select: none;
    cursor: pointer;
    .input-group-append {
      background: transparent;
    }
    .form-control {
      background: transparent !important;
    }
  }
  .input-group-append {
    cursor: pointer;
    background: #f0f0f0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-right: 8px;
    padding-top: 10px;
    margin-left: 0;
    font-size: 12px;
    color: #a0a0a0;
    border: 1px solid #ced4da;
    border-left: 0;
  }
  .form-control {
    cursor: pointer;
    &:disabled {
      background: #f0f0f0;
      border-right: 0;
    }
  }
}
.qty {
  &.form-control {
    background: #f0f0f0;
  }
}
.product-search {
  background-color: #fff;
  position: absolute;
  width: 99%;
  z-index: 9;
  ul {
    padding: 0;
    top: -350px;
    height: auto;
    max-height: 350px;
    border-radius: 0px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow-y: auto;
    @include custom-scrollbar();
    margin-bottom: 0px;
  }
  li {
    width: 100%;
    list-style-type: none;
    padding: 5px 15px;
    border-bottom: 1px #f0f0f0 solid;
    &:hover {
      background-color: #c0c0c0;
      color: #fff;
      cursor: pointer;
    }
    &:last-child {
      border-bottom: transparent !important;
    }
    p {
      font-weight: 300;
      font-size: 0.625rem;
    }
    h6 {
      font-weight: 400;
      font-size: 0.825rem;
      margin: 0px;
      text-align: left;
    }
    .row {
      display: table;
      width: 100%;
      .col {
        display: table-cell;
        vertical-align: middle;
        color: #000;
      }
    }
  }
}
</style>
